export default "__VITE_ASSET__Zy_EBeyV__"